module.exports = __webpack_public_path__ + "img/tarjeta-gold.49a7bfa2.webp";